import {
  Avatar,
  Button,
  Group,
  Image,
  Paper,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { FormattedMessage } from "react-intl";
import { AppWebviewLayout } from "../AppWebviewLayout";
import { FooterButtons } from "../../footerButtons";
import illustration from "../../../assets/fetching-offers.svg?url";
import diagramIconUrl from "../../../assets/diagram-green-icon.svg?url";
import calendarIconUrl from "../../../assets/calendar-green-icon.svg?url";
import transferIconUrl from "../../../assets/transfer-red-icon.svg?url";
import classes from "./PoaDataRetrievalScreen.module.css";

const points = [
  {
    icon: diagramIconUrl,
    id: "poaInfo.whatWeDo.bulletOne",
    defaultMessage:
      "Vi hämtar information om dina befintliga pensionsförsäkringar",
  },
  {
    icon: calendarIconUrl,
    id: "poaInfo.whatWeDo.bulletTwo.endDate",
    defaultMessage:
      "Du kan välja ett slutdatum för din fullmakt och återkalla den när du vill.",
  },
  {
    icon: transferIconUrl,
    id: "poaInfo.whatWeDo.bulletThree",
    defaultMessage:
      "Vi kommer <strong>INTE</strong> flytta eller ändra dina försäkringar.",
  },
];

export function PoaDataRetrievalScreen({
  onContinue,
  onBack,
}: {
  onContinue: () => void;
  onBack: () => void;
}) {
  return (
    <AppWebviewLayout footerSlot>
      <FooterButtons app>
        <Button variant="default" onClick={onBack} data-testid="back-button">
          <FormattedMessage id="bottomNav.back" defaultMessage="Tillbaka" />
        </Button>
        <Button onClick={onContinue}>
          <FormattedMessage id="bottomNav.next" defaultMessage="Nästa" />
        </Button>
      </FooterButtons>
      <Stack gap="lg">
        <Image
          src={illustration}
          alt=""
          h={140}
          w="auto"
          fit="contain"
          mx="auto"
        />

        <Stack gap="xs">
          <Title
            order={1}
            fz="h2"
            lh="h2"
            ff="var(--wallet-font-family-sambla-sans)"
            ta="center"
          >
            <FormattedMessage
              id="app.poaOnb.info.headline"
              defaultMessage="Vi hämtar dina pensionsuppgifter"
            />
          </Title>
          <Text size="sm" c="dimmed" ta="center" lh={1.5}>
            <FormattedMessage
              id="app.poaOnb.info.description"
              defaultMessage="För att skapa din pensionsöversikt behöver vi hämta uppgifter från dina pensionsbolag. Det görs via en informationsfullmakt från Fullmaktskollen."
            />
          </Text>
        </Stack>

        <Paper radius="lg" p="md" className={classes.card}>
          <Stack gap="md">
            <Title order={2} fz="sm" lh="md" fw={600}>
              <FormattedMessage
                id="app.poaOnb.info.list.title"
                defaultMessage="Vad det innebär:"
              />
            </Title>
            {points.map(({ icon, id, defaultMessage }) => (
              <Group key={id} gap="sm" align="flex-start" wrap="nowrap">
                <Avatar>
                  <img src={icon} alt="" width={26} height={26} />
                </Avatar>
                <Text size="xs" lh={1.5}>
                  <FormattedMessage id={id} defaultMessage={defaultMessage} />
                </Text>
              </Group>
            ))}
          </Stack>
        </Paper>
      </Stack>
    </AppWebviewLayout>
  );
}
